import axios from 'axios';
import { toast } from 'react-toastify';
import config from '../config/config';
import { t } from '../i18n';
import { translateBackendMessage } from './translateMessage';

const instance = axios.create({
  baseURL: config.API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor
instance.interceptors.request.use(
  (configur) => {
    const token = localStorage.getItem(config.APP_NAME + '_token');
    if (token) {
      configur.headers['Authorization'] = token;
    }
    return configur;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    let errorMessage = t('notifications.frontend.axios.unknownError');
    
    if (error.response) {
      // Server responded with error status
      const rawMessage = error.response.data?.message || error.response.data?.error;
      const translatedMessage = translateBackendMessage(rawMessage);
      errorMessage = translatedMessage || rawMessage || t('notifications.frontend.axios.serverError');
      if (error.response.data?.message && translatedMessage) {
        error.response.data.message = translatedMessage;
      }
      
      // Show toast notification
      toast.error(errorMessage, {
        autoClose: config.TOAST_AUTO_CLOSE,
        position: 'top-left',
        rtl: true
      });
    } else if (error.request) {
      // Network error - no response received
      errorMessage = t('notifications.frontend.axios.networkError');
      toast.error(errorMessage, {
        autoClose: config.TOAST_AUTO_CLOSE,
        position: 'top-left',
        rtl: true
      });
    } else {
      // Something else happened
      errorMessage = error.message || t('notifications.frontend.axios.unknownError');
      toast.error(errorMessage, {
        autoClose: config.TOAST_AUTO_CLOSE,
        position: 'top-left',
        rtl: true
      });
    }
    
    console.error('API Error:', errorMessage);
    return Promise.reject(error);
  }
);

export default instance; 